import { complianceSettingsCache } from "./ComplianceSettingsCache";
import { ComplianceSettingServiceApiClient } from "apiclient/ComplianceSettingServiceApiClient";
import { telemetry } from "core/TelemetryController";
import { RpcError, StatusCode } from "grpc-web";

export async function getComplianceSetting(
  apiEndpoint: string,
  auth0AccessToken: string,
  registryId: string
) {
  if (complianceSettingsCache.has(registryId)) {
    return complianceSettingsCache.get(registryId)!;
  }

  try {
    const client = new ComplianceSettingServiceApiClient(
      apiEndpoint,
      auth0AccessToken
    );

    const setting = await client.getComplianceSetting(registryId);

    // Store the result in cache.
    complianceSettingsCache.set(registryId, setting);

    return setting;
  } catch (error) {
    if (error instanceof RpcError && error.code === StatusCode.NOT_FOUND) {
      return null;
    } else {
      telemetry.logError(error);
      throw error;
    }
  }
}
